
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import {challengeModule, countriesState, teamModule, teamsState} from '@/utils/store-acessor';
  import {validators} from '@/utils/validations';
  import {TeamModel} from '@/models/team.model';
  import {ChallengeModel} from '@/models/challenge.model';
  import {HttpError} from '@/models/http.error';
  import ChallengeInvitation from '@/components/Challenges/tabs/teams/invites/TeamInvitation.vue';
  import {Ref} from 'vue-property-decorator';
  import {VForm} from 'vuetify/lib';
  import {API_URL} from '@/api/axios.config.api';

  @Component({
    components: {
      ChallengeInvitation
    }
  })
  export default class ChallengeTeamForm extends Vue {
    @teamModule.Getter('selectedTeam') selectedTeam!: TeamModel;
    @challengeModule.Getter('selectedChallenge') challenge!: ChallengeModel;
    // @ts-ignore
    @Ref() form!: VForm;
    errors = new HttpError();
    team: TeamModel = {
      name: ''
    };
    rules = validators;
    snackbarVisibility = false;
    snackbarColor: 'green' | 'red' = 'green';
    snackbarText: string = '';
    loading = false;
    valid = false;
    file: File | null = null;

    async mounted() {
      await countriesState.requestAllCountries();
      if (this.selectedTeam) {
        this.team = {...this.selectedTeam};
      }
    }

    async onCreateTeam() {
      this.loading = false;
      this.snackbarVisibility = false;
      if (this.form.validate()) {
        try {
          this.loading = true;
          if (this.challenge?.id) {
            if (!!this.team?.id) {
              await this.updateTeam(this.challenge.id, this.team.id);
            } else {
              await this.createTeam(this.challenge.id);
            }
          }
        } catch (e) {
          this.loading = false;
          this.errors = JSON.parse(JSON.stringify(e.response.data));
          this.displayMessage(`${this.errors.message}`, 'red');
        }
      } else {
        this.$vuetify.goTo(this.form, {offset: 20});
      }
    }

    private async updateTeam(challengeId: number, teamId: number) {
      if (this.file) {
        this.sendMultipart(challengeId, true, teamId)
      } else {
        await teamsState.updateTeam({
          challengeId,
          team: this.team
        });
        this.displayMessage('team.messages.create.success', 'green');
        this.loading = false;
        this.$router.replace({name: 'challenge-teams'});
      }
    }

    private async createTeam(challengeId:number) {
      if (this.file) {
        this.sendMultipart(challengeId, false)
      } else {
        await teamsState.createTeam({
          challengeId,
          team: this.team
        });
        this.displayMessage('team.messages.edit.success', 'green');
        this.loading = false;
        this.$router.replace({name: 'challenge-teams'});
      }
    }

    sendMultipart(challengeId: number, updating: boolean = false, teamId?: number) {
      const credentials = localStorage.getItem('credentials');
      if (!credentials) {
        return;
      }
      let url = `${API_URL}v1/contestants/challenges/${challengeId}/teams`;
      const formData = new FormData();
      formData.append('name', this.team.name);
      // @ts-ignore
      formData.append('banner', this.file);
      if (updating && teamId) {
        formData.append('_method', 'PUT');
        url += `/${teamId}`;
      }

      const xhr = new XMLHttpRequest();

      xhr.open('POST', url);
      const {token_type: type, access_token: token} = JSON.parse(credentials);
      xhr.setRequestHeader('Authorization', `${type} ${token}`);
      xhr.onloadstart = (e) => this.start(e);
      xhr.onloadend = (e) => this.finish(e);
      xhr.onload = (e) => this.success(e,updating);
      xhr.onerror = (err) => this.failed(err, updating);
      xhr.upload.onprogress = this.updateProgress;
      xhr.send(formData);
    }

    private displayMessage(message: string, color: 'green' | 'red') {
      this.snackbarVisibility = true;
      this.snackbarText = message;
      this.snackbarColor = color;
    }

    updateProgress(oEvent: ProgressEvent) {
      if (oEvent.lengthComputable) {
        const percentComplete = Math.round((oEvent.loaded * 100) / oEvent.total);
        this.progress(percentComplete);
      }
    }

    private start(event: any): any {
      return event
    }

    private finish(event: any): any {
      return event
    }

    private failed(err: any, updating: boolean = false) {
      if (updating) {
        this.displayMessage('team.messages.edit.failed', 'green');
      } else {
        this.displayMessage('team.messages.create.failed', 'green');
      }
    }

    private progress(value: number): number {
      return value;
    }

    private success(e: ProgressEvent, updating: boolean = false) {
      // @ts-ignore
      const team :TeamModel = e.currentTarget?.response;
      teamsState.upsertOne(team);
      if (updating) {
        this.displayMessage('team.messages.edit.success', 'green');
      } else {
        this.displayMessage('team.messages.create.success', 'green');
      }
      this.loading = false;
      this.$router.replace({name: 'challenge-teams'});
    }
  }
